import clsx from 'clsx'

let TelegramIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className)}
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width="34" height="34" rx="6" fill="#2AABEE"/>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.6969 16.819C12.6527 14.6598 15.9574 13.2363 17.6109 12.5486C22.332 10.5849 23.313 10.2438 23.9524 10.2325C24.093 10.2301 24.4075 10.2649 24.6112 10.4302C24.7831 10.5697 24.8305 10.7583 24.8531 10.8906C24.8757 11.0229 24.9039 11.3243 24.8815 11.5598C24.6257 14.2479 23.5187 20.7712 22.9555 23.7819C22.7172 25.0559 22.248 25.483 21.7937 25.5248C20.8065 25.6157 20.0568 24.8724 19.1007 24.2456C17.6044 23.2648 16.7592 22.6543 15.3068 21.6972C13.6284 20.5912 14.7165 19.9832 15.673 18.9898C15.9233 18.7297 20.273 14.7733 20.3572 14.4144C20.3678 14.3695 20.3775 14.2022 20.2781 14.1139C20.1787 14.0255 20.032 14.0557 19.9262 14.0798C19.7761 14.1138 17.3859 15.6937 12.7555 18.8193C12.077 19.2852 11.4625 19.5122 10.9119 19.5003C10.3049 19.4872 9.13729 19.1571 8.2693 18.875C7.20467 18.5289 6.35853 18.3459 6.43221 17.7582C6.47058 17.4521 6.89215 17.139 7.6969 16.819Z'
      fill='white'
    />
  </svg>
)

export default TelegramIcon
